/**
 * Created by Danila Krupnov on 7/30/25
 */

RewardsListComponent.prototype.createContent = cleverapps.extendFunc(RewardsListComponent.prototype.createContent, function () {
    const styles = cleverapps.styles.RewardsListComponent.content;
    this._super();

    this.content.setAlignment(styles.position);
});